<div
  (mouseenter)="activateAvatarMenu()"
  (mouseleave)="deactivateAvatarMenu()">
  <div class="navbar-avatar flex flex-row justify-center items-center">
    <app-avatar-icon data-qa="nav-avatar-icon" class="thumbnail"/>
    <app-all-icons data-qa="nav-avatar-arrow-down" [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'"/>
  </div>
  <div
    *ngIf="showAvatarMenu"
    @fadeInOut
    class="menu-wrapper flex flex-col content-center items-center">
    <div class="whitespace-0p5"></div>
    <div class="avatar-menu flex flex-col content-center items-stretch">
      <span
        data-qa="account-settings"
        class="flex items-center gap-[0.5rem]"
        routerLink="/cabinet"
        queryParamsHandling="preserve">
        <app-all-icons [iconNameAndStyling]="'user-icon-empty.svg;icon-size-1p25'"/>
        Account settings
      </span>
      <span
        *ngIf="showUserManagementOptions"
        data-qa="org-settings-menu-item"
        class="flex items-center gap-[0.5rem]"
        routerLink="/{{OrgUserManagementUrls.base}}/{{OrgUserManagementUrls._orgSettings}}"
        queryParamsHandling="preserve">
        <app-all-icons [iconNameAndStyling]="'buildings.svg;icon-size-1p25'"/>
        {{(orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin)? 'Organization settings' : 'Organization'}}
      </span>
      <span
        *ngIf="showUserManagementOptions"
        data-qa="users-management-menu-item"
        class="flex items-center gap-[0.5rem]"
        routerLink="/{{OrgUserManagementUrls.base}}/{{OrgUserManagementUrls._userSettings}}"
        queryParamsHandling="preserve">
        <app-all-icons [iconNameAndStyling]="'users-black-and-white.svg; icon-size-1p25'"/>
        {{(orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin) ? 'User management' : 'Users'}}
      </span>
      <span
        data-qa="support"
        class="flex items-center gap-[0.5rem]"
        (click)="mailToSupport()">
        <app-all-icons [iconNameAndStyling]="'sms-logo.svg;icon-size-1p25'"/>
        Support
      </span>
      <span
        data-qa="header-user-menu-logout"
        class="flex items-center gap-[0.5rem] red-10"
        (click)="logout()">
        <app-all-icons [iconNameAndStyling]="'exit.svg;icon-size-1p25'"/>
        Log out
      </span>
    </div>
  </div>
</div>

@if (showExpiredSessionModal){
  <app-modal-expired-session
    (goToLoginEmitter)="goToLogin()"
  />
}
